<script setup lang="ts">
import { computed } from 'vue';

/**
 * Centered “Our mission”–style block: small copper eyebrow + large statement (HTML).
 * Neo `aboutInfo` / legacy mission: description → eyebrow, simpleText → statement.
 * Neo `mission`: `heading` → eyebrow, `headingDescription` → statement (same roles as legacy `description` / `simpleText`).
 */
const props = withDefaults(
  defineProps<{
    eyebrow?: string;
    statementHtml?: string;
  }>(),
  {
    eyebrow: '',
    statementHtml: '',
  },
);

const show = computed(() => {
  const e = props.eyebrow?.trim() ?? '';
  const raw = props.statementHtml ?? '';
  const stripped = raw.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim();
  return e.length > 0 || stripped.length > 0;
});
</script>

<template>
  <section
    v-if="show"
    class="centered-statement-section pt-64 pb-32 font-inter md:py-80 lg:py-100"
  >
    <div class="container">
      <div class="mx-auto max-w-[900px] px-0 text-center lg:px-24">
        <p
          v-if="eyebrow?.trim()"
          class="text-18 font-semibold leading-125 text-copper-500"
        >
          {{ eyebrow.trim() }}
        </p>
        <div
          v-if="statementHtml"
          class="mt-16 font-inter-tight text-30 font-semibold leading-125 text-off-black-500 sm:mt-20 lg:mt-24 lg:text-40 lg:leading-120"
          v-html="statementHtml"
        />
      </div>
    </div>
  </section>
</template>
